'use strict';

const gtm = require('./modules/google').tagManager;

function isGiftsetFastlaneSite() {
    const headerLogo = $('.js-header-logo');
    const href = headerLogo.length > 0 && headerLogo[0].href;
    if (href) {
        return href.includes('gifting');
    }
    return false;
}

function pushDataLayerEventForFAQBlock(clickTarget) {
    if (!clickTarget || !isGiftsetFastlaneSite()) {
        return;
    }

    const dataLayerData = {
        'event': 'gst',
        'interaction': 'expand',
        'content_name': 'faq',
        'clickTarget': clickTarget
    };

    gtm.pushDataLayerEvent(dataLayerData);
}

module.exports = {
    pushDataLayerEventForFAQBlock: pushDataLayerEventForFAQBlock
};
